module.exports = __webpack_public_path__ + "img/photo.86931bc8.png";